import { Box, Typography } from "@mui/material";
import "../CSS/Layout.css";
import "../CSS/ResearchArea.css";
import { areaList, sponsorList } from "../Configurations/ResearchAreaList";

export default function ResearchAreaPage() {
  function Logos() {
    const logos = []
    for (var i = 0; i < sponsorList.length; i++) {
      logos.push(
        <a href={sponsorList[i].link} target="_blank" key={i} rel="noreferrer">
          <Box className="sponsor-logo"
            component="img"
            rel="noreferrer"
            src={sponsorList[i].img}
          />
        </a>)
    }
    return logos;
  }

  function areaSection() {
    const areas = [];
    for (var i = 0; i < areaList.length; i++) {
      areas.push(<Box className="area_block" key={i}>
        <Box className="area_image"
          component="img"
          rel="noreferrer"
          src={areaList[i].image}
        />
        <Box className="area_text">
          <Typography color="primary" fontWeight={800} fontSize={"2rem"}>
            {areaList[i].title}
          </Typography>
          <Typography mt="1.5rem" fontWeight={"2rem"}>
            {areaList[i].description}
          </Typography>
        </Box>
      </Box>);
    }
    return areas;
  }
  return (<>
    <Typography color="primary" fontSize="3rem" fontWeight={100} mb="4rem" className="sponsor-slogan">
      A special thanks to our sponsors
    </Typography>
    <Box className="logo-list">
      {Logos()}
    </Box>
    <Box className="flex-column" sx={{ gap: "120px", mt: "120px" }}>
      {areaSection()}
    </Box>
  </>);
}